var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEmailValid } from '../ValidationUtils';
export var handleValidEmail = function (_a) {
    var event = _a.event, fieldErrorChange = _a.fieldErrorChange, fieldsErrors = _a.fieldsErrors, formData = _a.formData, onChange = _a.onChange;
    var email = event.target.value;
    onChange(__assign(__assign({}, formData), { email: email }));
    if (!email) {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), { emailError: 'O campo deve ser informado.' }));
        return false;
    }
    if (!isEmailValid(email)) {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), { emailError: 'Por favor, insira um e-mail válido' }));
        return false;
    }
    fieldErrorChange(__assign(__assign({}, fieldsErrors), { emailError: '' }));
    return true;
};
